import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { useCart } from "@/context/CartContext";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const CheckoutSuccess = () => {
  const [params] = useSearchParams();
  // PayPal redirects back with ?token={ORDER_ID}&PayerID={PAYER_ID}
  const orderId = params.get("token") || params.get("order_id");
  const { clearCart } = useCart();
  const [status, setStatus] = useState("checking");
  const [info, setInfo] = useState(null);
  const startedRef = useRef(false);

  useEffect(() => {
    if (!orderId) {
      setStatus("failed");
      return;
    }
    // Run capture only once across mounts (StrictMode double-mounts in dev)
    if (startedRef.current) return;
    startedRef.current = true;

    (async () => {
      try {
        const { data } = await axios.post(`${API}/paypal/capture-order`, {
          order_id: orderId,
        });
        setInfo(data || null);
        const ok =
          data &&
          (data.status === "COMPLETED" ||
            data.already === true ||
            (typeof data.status === "string" && data.status.toUpperCase() === "COMPLETED"));
        if (ok) {
          setStatus("paid");
          clearCart();
        } else {
          setStatus("failed");
        }
      } catch (e) {
        setStatus("failed");
      }
    })();
  }, [orderId, clearCart]);

  return (
    <div className="page-narrow" data-testid="checkout-success-page">
      <div className="status-card">
        {status === "checking" && (
          <>
            <Loader2 size={36} className="spin" />
            <h2>Confirming your order…</h2>
            <p>Hold tight — we&apos;re finalizing payment with PayPal.</p>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle2 size={44} className="ok" />
            <h2 data-testid="payment-success">ORDER CONFIRMED.</h2>
            <p>
              Thanks for riding with Erydon. We&apos;ll email you tracking once
              your machine ships from the workshop.
            </p>
            {info && info.payer_email && (
              <p className="muted">PayPal account: {info.payer_email}</p>
            )}
            {info && info.capture_id && (
              <p className="muted">Capture ID: {info.capture_id}</p>
            )}
            <Link to="/" className="btn btn-primary">BACK TO HOME</Link>
          </>
        )}
        {status === "failed" && (
          <>
            <XCircle size={44} className="bad" />
            <h2 data-testid="payment-failed">Payment Not Confirmed</h2>
            <p>We couldn&apos;t finalize your payment. If you were charged, contact support.</p>
            <Link to="/cart" className="btn btn-primary">BACK TO CART</Link>
          </>
        )}
      </div>
    </div>
  );
};

export default CheckoutSuccess;
